<!-- 百分比上传组件 -->

<template>
  <div class="load-btn">
    <el-upload
      ref="upload"
      :aciton="loadUrl"
      :disabled="pubStatus != 0"
      v-show="upState == 'wait' || upState == 'loaded'"
      class="upload-btn"
      :before-upload="prevCtrls"
      :on-progress="pgressCtrls"
      :on-error="errorCtrls"
      :on-success="successCtrls"
      :show-file-list="false"
      multiple
      :limit="1"
      :on-exceed="handleExceed"
      :headers="postHead">
      <el-button v-if="upState == 'wait'" :disabled="pubStatus != 0" size="mini" type="primary">上传</el-button>
      <el-button v-if="upState == 'loaded'" :disabled="pubStatus != 0" size="mini" type="primary">更新</el-button>
    </el-upload>
    <el-progress v-show="upState == 'loading'" type="circle" :percentage="percentage" :width="45" :stroke-width="3">
    </el-progress>

    <el-button size="mini" type="warning" v-show="upState == 'loaded'" @click="filesDown"> 下载 </el-button>
  </div>
</template>

<script>
import { filesDownloadUploadBtn } from "@/api/file";
import { getToken } from "@/utils/auth";
import { getFileToken } from "@/api/account";
export default {
  props: ["fileID", "btnProps", "pubStatus"],
  data() {
    return {
      percentage: 0,
      upState: "wait",
      stmpState: "wait",
      loadUrl: "",
      fileToken: "",

      postHead: {},
    };
  },
  watch: {
    fileID: function (newDat) {
      if (newDat) {
        this.upState = "loaded";
        this.urlInit(this.response.payload.id);
      }
    },
    pubStatus: function (newDat) {
      this.pubStatus = newDat;
    },
  },
  methods: {
    prevCtrls: function (file) {
      let nameArr = file.name.split(".");
      if (nameArr[nameArr.length - 1] != "doc" && nameArr[nameArr.length - 1] != "docx") {
        this.$message({
          message: "请上传 word 格式的文件！",
          type: "error",
        });
        return false;
      } else if (file.size / 1024 / 1024 > 100) {
        this.$message({
          message: "文件大小不能超过 100M！",
          type: "error",
        });
        return false;
      } else {
        this.postHead["Authorization"] = `Bearer ${getToken()}`;
        this.upState = "loading";
        return true;
      }
    },
    pgressCtrls: function (evt, file) {
      this.percentage = parseInt(file.percentage);
    },
    errorCtrls: function (err) {
      this.upState = "wait";
      this.$alert("上传失败，请稍后重试！", "提示", {
        confirmButtonText: "确定",
        type: "error",
      });
    },
    successCtrls: function (response, file) {
      // console.log("successCtrls=",JSON.stringify(response.payload));
      // console.log("file=",JSON.stringify(file));
      if (response.code != 0) {
        this.upState = "wait";
        this.$alert("上传失败，请稍后重试！", "提示", {
          confirmButtonText: "确定",
          type: "error",
        });
      } else {
        // 上传成功之后，需要把数据写入到表中，如果之前有文件信息，需要再删除掉
        this.$emit("zeroTabStore", response.payload.id, this.btnProps);
        this.percentage = 100;
        this.upState = "loaded";
      }
    },
    urlInit: function (dat) {
      console.log("dat=", dat);
      if (dat) {
        this.upState = "loaded";
        // this.loadUrl = process.env.BASE_API + '/File/File/download/token/' + this.fileToken + '/id/' + dat;
        // console.log("uploadBtn.vue > loadUrl:" + this.loadUrl)
        // if (this.loadUrl == undefined) {
        //   this.loadUrl = ""
        // }
      }
    },
    handleExceed: function () {
      this.$message.error("只能选择一个文件");
    },
    filesDown: function () {
      // console.log("filesDown:", this.btnProps);
      if (this.btnProps.id && (this.btnProps.materialCode || this.btnProps.code)) {
        var dataIn = {};
        dataIn.organizationMaterialId = this.btnProps.id;
        // zym.20250610，兼容连续型出版物，需要使用code、name
        dataIn.code = this.btnProps.materialCode || this.btnProps.code;
        dataIn.materialTitle = this.btnProps.materialTitle || this.btnProps.name;
        // console.log("dataIn=", dataIn);
        filesDownloadUploadBtn(dataIn).then((response) => {
          // console.log('response=',JSON.stringify(response));
          // roro
          //   response.payload.url = CONST.PATH_TSNJ + response.payload.catalog
          if (response.payload.url) {
            if (this.type == "img") {
              this.$emit("openImage", response.payload.url, this.type);
            } else {
              window.open(response.payload.url);
            }
          }
        });
      }
    },
  },
  mounted: function () {
    let vm = this;
    console.log("uploadBtn.vue > loadUrl:" + this.loadUrl);
    this.$refs.upload.$refs["upload-inner"].uploadFiles = function (files) {
      let svm = vm.$refs.upload.$refs["upload-inner"];
      if (svm.limit && svm.fileList.length + files.length > svm.limit) {
        svm.onExceed && svm.onExceed(files, svm.fileList);
        return;
      }
      let postFiles = Array.prototype.slice.call(files);
      if (!svm.multiple) {
        postFiles = postFiles.slice(0, 1);
      }
      if (postFiles.length === 0) {
        return;
      }
      postFiles.forEach((rawFile) => {
        svm.onStart(rawFile);
        // rawFile.postUrl = process.env.BASE_API + '/File/File/upload';
        rawFile.postUrl = process.env.BASE_API + "/eavar/file/upload";
        if (svm.autoUpload) svm.upload(rawFile);
      });
    };

    this.$refs.upload.$refs["upload-inner"].post = function (rawFile) {
      const { uid } = rawFile;
      let svm = vm.$refs.upload.$refs["upload-inner"];
      let s = {
        token: getToken(),
        // fileToken:rawFile.token,
        fileSize: rawFile.size,
      };
      // this.postHead['Authorization'] = `Bearer ${getToken()}`;
      // console.log({Authorization:`Bearer ${getToken()}`})
      // svm.headers = {Authorization:`Bearer ${getToken()}`};
      console.log("svm=", svm);
      const options = {
        headers: svm.headers,
        withCredentials: this.withCredentials,
        file: rawFile,
        data: s,
        filename: svm.name,
        action: rawFile.postUrl || "",
        onProgress: (e) => {
          svm.onProgress(e, rawFile);
        },
        onSuccess: (res) => {
          svm.onSuccess(res, rawFile);
          delete this.reqs[uid];
        },
        onError: (err) => {
          svm.onError(err, rawFile);
          delete this.reqs[uid];
        },
      };

      console.log("options=", JSON.stringify(options));

      const req = svm.httpRequest(options);
      svm.reqs[uid] = req;
      if (req && req.then) {
        req.then(options.onSuccess, options.onError);
      }
    };
  },
  created: function () {
    // getFileToken().then(response => {
    //   this.fileToken = response.resultStatus.token;
    //   this.urlInit(this.fileID);
    // });
    console.log("fileID=", this.fileID);
    console.log("btnProps=", JSON.stringify(this.btnProps));
    this.urlInit(this.fileID);
  },
};
</script>

<style>
.upload-btn {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// uploadBtn.vue?61256d27